import { FEATURE_FLAGS } from '../constants/featureFlags';
import { useTeamQuery } from '../graphql/team/queryTeam';
import { isFeatureFlagEnabled } from '../utils/featureFlags';

export type TrendSignalsFlag = {
  enabled: boolean;
  /** The team, and so its flag list, has loaded. Until then `enabled` reads false. */
  resolved: boolean;
  /** The team query settled with an error or without a team, so the flag will not resolve. */
  failed: boolean;
};

/**
 * Based on the `trend_signals` team feature flag (status-aware, like `useIsDemoTeam`).
 */
export function useTrendSignalsFlag(): TrendSignalsFlag {
  const query = useTeamQuery();
  const team = query?.data?.team;
  return {
    enabled: isFeatureFlagEnabled(team?.featureFlags, FEATURE_FLAGS.TREND_SIGNALS),
    resolved: team != null,
    failed: team == null && query?.loading === false,
  };
}

export function useTrendSignalsEnabled(): boolean {
  return useTrendSignalsFlag().enabled;
}
